import { createContext, useContext } from 'react'

// Context for additive search providers (e.g. help articles, product navigation).
// These providers run alongside the primary provider and contribute supplementary
// results that are displayed in separate UI slots, not replacing the main results.

const defaultValue = {
  // Array of result blocks, one per registered additive provider.
  //
  // Shape: Array<{
  //   providerId:   string,
  //   hits:         any[],          // flat hits across the provider's domain
  //   indexResults: Object | undefined,
  //                                 // when set, mirrors AlgoliaSearchProvider's
  //                                 // per-index shape:
  //                                 //   { repos:          { hits, hitCount, hasMore, loadMore },
  //                                 //     folders:        { hits, hitCount, hasMore, loadMore },
  //                                 //     sets_questions: { hits, hitCount, hasMore, loadMore } }
  //                                 // Only providers that emit per-index data
  //                                 // populate this (non-content registries).
  // }>
  additiveResults: [],
  // Which local engine the UI presents for non-content slots. Content search is
  // Algolia-only; the local content engine runs as a shadow. Consumers use this
  // (via localProviderId) for nav/external/QA.
  presentationEngine: 'minisearch',
}

export const SupplementarySearchContext = createContext(defaultValue)

export function useSupplementarySearch() {
  return useContext(SupplementarySearchContext)
}
